import React from 'react';
import './SkinName.css';

function SkinName({ text }) {
  if (!text) return null;
  return (
    <div className="skin-name">
      <div className="skin-name__inner">
        <span className="skin-name__text">{text}</span>
      </div>
    </div>
  );
}

export default SkinName;


